import styled from 'styled-components';

export const Assinatura = styled.section`
    display: flex;
    background-color: var(--primary);
    width: 100%;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
    gap: 15px;
`;

export const Versao = styled.div`
    display: flex;
    background-color: var(--primary);
    width: 100%;
    justify-content: center;
    align-items: center;
    font-size: 8px;
    font-weight: bold;
    color: #FFFFFF;
`;

export const Footer = styled.div`
    bottom: 50px;
    position: fixed;
    margin-bottom: 18px;
`;

export const TextLight = styled.p`
    font-size: 8px;
    color: var(--white);
`;
